const inputsValidations = {
  emailRequired: "Email is required",
  nameRequired: "Name is required",
  enNameRequired: "English name is required",
  arNameRequired: "Arabic name is required",
  pickOneSubCategoryAtLeast:
    "At least one sub category must be selected",
  specialtyRequired: "Specialty is required",
  roleRequired: "Role is requierd",
  logoRequired: "Logo is requierd",
  bannerRequired: "Banner is requierd",
  subCategoryRequired: "Sub Category is requierd",
  passwordRequired: "Password is required",
  tempPasswordRequired: "Temporary password is required",
  oldPasswordRequired: "Old password is required",
  newPasswordRequired: "New password is required",
  validEmailFormat: "Please enter a valid email format",
  uniqeEmailRequired:
    "This email is used before, email should be uniqe",
  confirmNewPasswordRequired: "Confirm new password is required",
  passwordIsNotMatched: "Passwords must match",
  passwordNotFollowREGEX:
    "Password should contain at least 8 characters; mix of letters (upper and lower case), numbers, and symbols",
  nameNotFollowREGEX:
    "Name should not contain any special characters",
  englishLettersOnly: "This field only accepts English input",
  arabicLettersOnly: "This field only accepts Arabic input",
  rejectionReasonMaxChar:
    "Rejection reason can't exceed 100 characters",
  CategoryNameRequired: "Category Name is required",
  CategoryDescriptionRequired: "Category Description is required",
  categoryListCoverImageRequired: "Category cover is required",
  adminListCoverImageRequired: "Category image is required",
  categoryNameLong:
    "category Name can not be more than 50 characters",
  categoryDescriptionLong:
    "Category Description can not be more than 500 characters",
  uploadImgSizeError:
    "Minimum accepted quality for image is 256px*256px ",
  uploadTypeError:
    "Accepted formats are jpg, jpeg, png, and bmp only",
  uploadSizeError: "Max Image size is 2MB",
  subCategoryNameRequired: "Name is required",
  subCategoryDescriptionRequired: "Description is required",
  subCategoryImageRequired: "Sub Category Image is required",
  subCategoryCoverImageRequired: "Sub Category Cover is required",
  subCategoryNameLong: "Name can not be more than 50 characters",
  subCategoryDescriptionLong:
    "Description can not be more than 500 characters",
  subCategoryParentCategoryRequired: "Category is required",
  subCategorySpecificationsRequired:
    "You must insert at least one suggestion",
  subCategorySpecificationsSuggestionsRequired:
    "The suggestion is required",
  subCategorySpecificationsMaxNumber:
    "The max number of suggestions allowed is 10",
  subCategorySpecificationsMaxLength:
    "Suggestion can not be more than 30 characters",
  subCategorySpecificationsUnique: "Suggestion can not be repeated",
  offplatformDocumentMaxLength:
    "Document name can not be more than 50 characters",
  offplatformDocumentUnique: "Document name can not be repeated",
  offplatformDocumentIsRequired: "Document is required",
  pdfAndImgsAllowed:
    "Accepted formats are pdf, jpg, jpeg, png, and bmp only",
  uploadFileSizeError: "Max file size is 2MB",
  invalidFileType: "Only .pdf files allowed",
  requestOffPlatformDocsUpdatesRequired:
    "You need to enter the requested updates",
  requestOffPlatformDocsUpdatesMaxLength:
    "Updates can not be more than 200 characters",
  voucherPercentageLimitExceeded:
    "Please enter a valid percentage between 1 and 100",
  invalidVoucherPercentage:
    "Please enter a valid percentage between 1 and 100 with up to 1 decimal place",
  voucherPercentageRequired: "Voucher percentage is required",
  companyNameRequired: "Company name is required",
  employeeMobileNumberLength:
    "Phone number should be minimum 6 digits",
  invalidFullName:
    "The input must include letters. Special characters are allowed only if there is at least one letter, but numbers are not allowed",
  invalidPassword: "Invalid Password",
  roleNameRequired: "Role Name is required",
  roleNameLength: "Role Name can not be more than 50 characters",
  roleDescriptionLength:
    "Role Description can not be more than 200 characters",
  rejectionReasonRequired: "Rejection reason is required",
  verificationRejectionReasonMaxChar:
    "Rejection reason can't exceed 200 characters",
  suggestedCategoryRejectionReasonMaxChar:
    "Rejection reason can't exceed 200 characters",
  employeeNameLong: "Full name can not be more than 50 characters",
  uploadVideoTypeError: "Accepted format is mp4 only",
  uploadImgTypeError:
    "Accepted formats are jpg, jpeg, png, and bmp only"
};

export default inputsValidations;
